import React from 'react';
import {connect} from 'react-redux';

import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';

import {Link} from 'react-router';

class Terms extends React.Component {

    render() {
        return <FullWidthPage>
            <div className="col-md-12">
                <SectionTitle>Условия за ползване</SectionTitle>

                <p><Link to="/">medita.bg</Link> предлага водени медитации на български език.</p>

                <p>Услугата ни е безплатна. Тя следва да се използва от пълнолетни лица над 18 години или за
                    непълнолетните под родителски контрол.</p>

                <p>Информацията на сайта е изцяло информативна и не може да се счита за медицински съвет. Нашите
                    програми не са създадени с цел да диагностицират, предотратяват или лекуват дадено състояние или
                    заболяване, да определят здравословното Ви състояние или да заменят професионална медицинска помощ.
                    Не всички услуги са подходящи за всеки. Ако се в остра фаза на клинична депресия или страдате от
                    психоза е необходимо да се консултирате с лекар преди да практикувате медитация. Не използвайте
                    услугите докато шофирате, докато използвате тежки машини или докато изпълнявате други задачи, които
                    изискват внимание и концентрация. Вие разбирате и се съгласявате, че сте изцяло отговорен за начина,
                    по който използвате услугата.</p>
        
                <p>Medita.bg предоставя достъп до определен брой безплатни медитации, както и до медитации достъпни след закупуването на абонамент. Абонамент може да се закупи чрез In-App плащане. Плащането ще бъде начислено на Вашия Apple ID или Google Play акаунт при потвърждаването на покупката или при изтичане на безплатния пробен период. Абонаментът ще бъде подновен автоматично освен, ако не е прекратен най-малко 24 часа преди края на текущия период. Вашият акаунт ще бъде таксуван за подновяването в срок от 24 часа преди края на текущия период. Можете да управлявате или прекратите абонамента си като отворите настройките на App Store или Play Store след направена покупка.</p>

                <p>Всички изказвания и публикации за ползите от медитацията са изцяло базирани на публична информация от
                    книги и материали в Интернет.</p>

                <p>Медитацията е помогнала на много хора от векове насам. Надяваме се да помогне и на теб.</p>

                <p>Нашите медитации са изготвени от хора, които са Интернет ентусиасти и мечтаят и работят за свят с
                    повече усмихнати, здрави хора и с по-малко насилие.</p>

                <p>Ние нямаме специализирано образование и не сме лицензирани преподаватели по медитация. Използвайки
                    нашата услуга, Вие се съгласявате да ни освободите от всякаква отговорност за евентуално претърпени
                    вреди или понесени щети.</p>

                <p>Използвайте нашите аудио записи на своя отговорност.</p>

                <p>Ние ценим и сме благодарни за всяка обратна връзка и планираме да я използваме, за да подобряваме
                    непрекъснато нашата услуга и за рекламни цели.</p>

                <p>Ако желаете повече информация за нас и нашия продукт, моля свържете се с нас по имейл: <a
                    href="mailto:hi@medita.bg">hi@medita.bg</a>.</p>

            </div>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(Terms);




// WEBPACK FOOTER //
// ./src/components/Pages/Terms.js